import React, { Component, Fragment } from 'react';
import {
    getTitleTable, columnsTable,
    getDataSource, formatValidation,
    getPathWithParams,
} from '../../../../../helpers/functions';
import { getLocaleFullName } from '../../../../../utils/commonUtils';
import { Link } from 'react-router-dom';
import { DATE_TIME_FORMAT, PATHS, ORDER } from '../../../../../constants/Define';
import { ParamsClass } from '../../../../../constants/ColorPage';
import { ListComponent } from '../../../common/component/Index';
import Rating from '../../../../../models/Rating';
import Wrapper from './../../../common/component/Wrapper';
import Modal from './../../../common/component/Modal';
import Dropdown from './../../../common/component/Dropdown';
import Button from './../../../common/component/Button';
import Span from './../../../common/component/Span';
import EllipsisText from './../../../common/component/EllipsisText';
import Comment from './../../../common/component/Comment';
import FontIcon, { SolidIcons } from './../../../common/component/FontIcon';
import { Rate, Icon, Menu, Tooltip, List, Badge, Popover } from 'antd';
import Images from '../../../../../constants/Images';
import { get, find } from 'lodash';
import './RatingList.less';

let permisionActions = [];
const defaultState = {

};

const ReportListCols = [
    'productName', 'productType', 'fullName', 'ratingValue',
    'titleRating', 'comment', 'createdDate'
];
export default class RatingList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, ['action'], []),
            modelItem: Object.getOwnPropertyNames(new Rating()),
            componentTable: {
                productName: {
                    sorter: (i, k) => (i.productName || '').length - k.length,
                    key: 'productName',
                    width: 200,
                    render: (text, record) => this.renderEllipsisText(this.props.t(`item.rating.productName`), text, 180),
                },
                productType: {
                    sorter: (i, k) => (i.productType || '').length - k.length,
                    key: 'productType',
                    align: 'center',
                    render: (typeId) => {
                        const type = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === typeId)
                        return (
                            <Tooltip title={this.props.t(`item.order.orderTypes.${type.toLowerCase()}`)}>
                                <Span className="ml-2">
                                    <FontIcon key={type} color={ORDER.TYPES[type].color} icon={SolidIcons[ORDER.TYPES[type].icon]} size="lg" />
                                </Span>
                            </Tooltip>
                        )
                    },
                },
                fullName: {
                    render: (text, record) => getLocaleFullName(record.firstName, record.lastName),
                },
                ratingValue: {
                    sorter: (i, k) => (i.ratingValue || '').length - k.length,
                    key: 'ratingValue',
                    align: 'center',
                    render: (text, record) => <Rate disabled value={record.ratingValue} />,
                },
                titleRating: {
                    key: 'title',
                    render: (text, record) => this.renderEllipsisText(this.props.t(`item.rating.titleRating`), record.title, 150),
                },
                comment: {
                    render: (text, record) => this.renderEllipsisText(this.props.t(`item.rating.comment`), text, 150),
                },
                createdDate: {
                    render: (text, record) => record.createdDate && record.createdDate.format(DATE_TIME_FORMAT.DATE_TIME),
                    sorter: (i, k) => (i.createdDate || '').length - k.length,
                    key: 'createdDate',
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            expandedRows: [],
        };
    }

    render() {
        const { t, ratings, pagination, loading } = this.props;
        const { titleItemTable, modelItem, componentTable, expandedRows } = this.state;

        return (
            <ListComponent
                tableKey="rating-list"
                classParent="m-0 p-0 col-md-12 mt-2 rating-list"
                classChildren="m-0 p-0"
                marginTop={'0'} marginBottom={'0'}
                loading={{ spinning: loading, size: 'large' }}
                rowKey={(record, k) => record.id ? record.id : k}
                dataSource={getDataSource(ratings, modelItem)}
                columns={columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'rating'
                })}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.pageIndex, defaultPageSize: pagination.pageSize }}
                onChange={this.onTableChange}
                componentTableList={{}}
                expandedRowRender={this.renderReplies}
                expandedRowKeys={expandedRows}
                onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                expandIcon={this.renderExpandIcon}
            />
        );
    }

    renderReplies = (rating, index, indent, expanded) => {
        const { t, permissions, approvingId } = this.props;
        const removeItem = (reply, isRating = false) => {
            if (isRating) {
                this.props.onDeleteRating && this.props.onDeleteRating(reply)
            }
            return this.props.onDeleteReply && this.props.onDeleteReply(reply)
        }
        const onRemove = (reply, isRating = false) => {
            const { confirm } = Modal;
            confirm({
                title: formatValidation(t('validation.statusCode.code.7'), t(`item.rating.${isRating ? 'title' : 'replies'}`)),
                content: reply.comment,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: () => removeItem(reply, isRating),
            });
        };

        const renderActionButtons = (reply, isRating = false) => {
            return [(
                permissions && permissions.allowApprove &&
                <Tooltip title={reply.isApproved ? t(`item.rating.hideThisComment`) : t(`item.rating.showThisComment`)}>
                    <Button type="link" size="small" className="pl-0 pr-0"
                        onClick={() => isRating ? this.props.onApproveRating(reply) : this.props.onApproveReply(reply)}>
                        {this.renderApproveIcon(!reply.isApproved, approvingId === reply.id, 14)} {!reply.isApproved ? t(`action.approve`) : t(`action.unapprove`)}
                    </Button>
                </Tooltip>
            ), (
                permissions && permissions.allowDelete &&
                <Button icon="delete" type="link" size="small" className="pl-0 pr-0 ml-2"
                    onClick={() => onRemove(reply, isRating)}>{t(`action.remove`)}</Button>
            )]
        }
        const replies = (rating.replies || []).map(reply => this.renderReplyItem(reply, renderActionButtons(reply)));
        const ratingActions = renderActionButtons(rating, true);
        return (
            <List
                className="comment-list"
                header={<Comment {...this.renderReplyItem(rating, ratingActions)} />}
                itemLayout="horizontal"
                dataSource={replies}
                renderItem={item => (<li className="ml-5"><Comment {...item} /></li>)}
            />
        )
    }

    renderReplyItem = (reply, actions) => {
        const { t } = this.props;
        if (reply.replies && reply.replies.length) {
            actions = [(
                <Button icon="message" type="link" size="small" className="pl-0 pr-0 mr-2"
                    style={{ cursor: 'default', color: 'grey' }}
                >{`${reply.replies.length} ${t(`item.rating.replies`).toLowerCase()}`}</Button>
            )].concat(actions)
        }
        return {
            actions,
            author: getLocaleFullName(reply.firstName, reply.lastName),
            content: <Wrapper>
                {!!reply.ratingValue && <Rate disabled value={reply.ratingValue} />}
                <p className={!!reply.ratingValue ? 'mt-1' : ''}>{reply.comment}</p>
            </Wrapper>,
            avatar: Images.defaultAvatar,
            datetime: (
                <Tooltip title={reply.createdDate && reply.createdDate.format(DATE_TIME_FORMAT.DATE_TIME)}>
                    <span>{reply.createdDate && reply.createdDate.fromNow()}</span>
                </Tooltip>
            ),
        }
    }

    renderEditComponent(item) {
        const { t, permissions, approvingId } = this.props;
        const removeItem = () => {
            return this.props.onDeleteRating && this.props.onDeleteRating(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: formatValidation(t('validation.statusCode.code.7'), t(`item.rating.title`)),
                content: item.title,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>
                {(item.isApproved || approvingId === item.id) &&
                    <Tooltip title={t(`item.rating.beApproved`)}>
                        {this.renderApproveIcon(item.isApproved, approvingId === item.id, undefined, ParamsClass['@primary-color'])}
                    </Tooltip>
                }
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {/* <Menu.Item>
                            <Link to={getPathWithParams(PATHS.RATING.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                <Icon type="eye" className="fs20 mr-1" /> {t(`action.detail`)}
                            </Link>
                        </Menu.Item> */}
                        {
                            permissions && permissions.allowApprove &&
                            <Menu.Item onClick={() => this.props.onApproveRating(item)}>
                                {this.renderApproveIcon(!item.isApproved)} {!item.isApproved ? t(`action.approve`) : t(`action.unapprove`)}
                            </Menu.Item>
                        }
                        {
                            permissions && permissions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    renderApproveIcon(isApproved, loading, size, color) {
        return <Icon className="fs20 m-0 p-0" style={{ fontSize: size, color }} type={loading ? 'loading' : undefined}
            component={() => <FontIcon icon={SolidIcons[isApproved ? 'faCheck' : 'faBan']} />} />
    }

    renderExpandIcon = ({ record, onExpand, expanded }) => {
        const { t } = this.props;
        return (record.replies.length ?
            <Badge count={!expanded ? record.replies.length : 0} style={{ backgroundColor: ParamsClass['@primary-color'] }}>
                <Icon type={!expanded ? 'message' : 'caret-up'} className="fs20 cursorPointer" onClick={(e) => onExpand(record, e)} />
            </Badge>
            : <Tooltip title={t(`item.rating.noReply`)}>
                <Icon type="message" className="fs20" style={{ opacity: 0.3 }} />
            </Tooltip>
        )
    }

    renderEllipsisText = (title, text, maxWidth = 100) => {
        return (
            <EllipsisText title={title}
                content={text} contentMaxWidth={maxWidth}
                overlayClassName={'max-width-500'} overlayComponent={Popover} />
        )
    }

    onTableChange = (pagination, filters, sorter) => {
        this.setState({ expandedRows: [] });
        return this.props.onChange(pagination, filters, sorter)
    }

    collapseAllRow = () => {
        this.setState({ expandedRows: [] });
    }

}

RatingList.defaultProps = {
    ratings: {},
    pagination: {},
    loading: false,
    approvingId: undefined,
    onChange: (pagination, filters, sorter) => { },
    onDeleteRating: (rating) => { },
    onApproveRating: (rating) => { },
    onDeleteReply: (reply) => { },
    onApproveReply: (reply) => { },
}

